$component-class: 'dh-icon';
$icon-size-sm: 16px;
$icon-size-md: 24px;
$icon-size-lg: 32px;

dh-icon {
  line-height: 0;
}

.#{$component-class} {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    transition: fill 0.2s ease;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

.#{$component-class}--sm {
  @include size($icon-size-sm);
}

.#{$component-class}--lg {
  @include size($icon-size-lg);
}
